import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup } from '@angular/forms';
import { environment } from 'src/environments/environment';

export interface IProductNotesDialogData {
  productName: string;
  productImage: string;
  note: string;
  /** When false, the dialog is a read-only viewer (no Save/Delete). */
  editable: boolean;
}

export interface IProductNotesDialogResult {
  /** Trimmed note. Empty string means the note was deleted/cleared. */
  note: string;
}

@Component({
  selector: 'app-product-notes-dialog',
  templateUrl: './product-notes-dialog.component.html',
  styleUrls: ['./product-notes-dialog.component.scss'],
})
export class ProductNotesDialogComponent implements OnInit {
  notesForm!: FormGroup;
  baseUrl = environment.BASE_URL_API;

  constructor(
    private dialogRef: MatDialogRef<ProductNotesDialogComponent, IProductNotesDialogResult>,
    private formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: IProductNotesDialogData,
  ) {}

  ngOnInit(): void {
    this.notesForm = this.formBuilder.group({
      note: [{ value: this.data?.note ?? '', disabled: !this.data?.editable }],
    });
  }

  get productImage(): string {
    return this.data?.productImage ? this.baseUrl + this.data.productImage + '?thumbnail=1' : 'assets/icones/default-image-product.svg';
  }

  get hasExistingNote(): boolean {
    return !!(this.data?.note && this.data.note.trim());
  }

  save(): void {
    if (!this.data?.editable) return;
    const note = (this.notesForm.get('note')?.value ?? '').trim();
    this.dialogRef.close({ note });
  }

  delete(): void {
    if (!this.data?.editable) return;
    this.dialogRef.close({ note: '' });
  }

  close(): void {
    this.dialogRef.close();
  }
}
